import { ControllableConsumptionDevicesFormStep } from '@/types/forms/formSteps/controllableConsumptionDevicesFormStep';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import { isStorageChargeFromPublicGrid } from './common';
import { getOverallActivePower } from '../../utilities/application/plantPerformance';

export const controllableConsumptionDevicesRules = async (
    formStep: {
        model: ControllableConsumptionDevicesFormStep;
        formModel: ApplicationForm;
    } & Vue,
): Promise<void> => {
    formStep.model.maxConnectionLoad.disabled = !(
        isStorageChargeFromPublicGrid(formStep.formModel.plantData) &&
        formStep.model.gridControlImplementationPreference.value ===
            'indirectLoadMgmt'
    );

    const overallActivePower =
        getOverallActivePower(
            formStep.formModel.applicationType,
            formStep.formModel.plantPerformance,
        ) ?? 0;

    formStep.model.connectionTypeSelector.disabled = overallActivePower > 100;
};
